export default {
  slug: "jetbrains-air",
  code: "AIR",
  label: "JetBrains Air",
  // The banner design writes the product name alone, in Modul.
  shortLabel: "Air",
  logoFamily: "jb-black",
  // Releases lists AIR under the "Release" stage alone, and Social lists it
  // too; both reach the same offering (src/data/offering.ts). The Set filter is narrower than the channel's full
  // list: Air ships no splash screen and no wallpapers, and it publishes no
  // webpage preview. Screenshots is not one of the design frame's own sets —
  // the frame draws no 1920x1080 template — but the Screenshot set is the
  // shared mockup tool (a screenshot upload over a background, with the cursor
  // and overlay controls), which carries no product branding to conflict with
  // the Air design, so Air offers it like every other product.
  // The order must stay a subsequence of RELEASES_SETS (data/constants.js).
  releasesSets: ["social-media", "whats-new", "emails", "screenshots"],
  // The Modul display face is licensed for Air only, so the font is scoped to
  // this product rather than declared globally. See src/css/fonts.css.
  hasModulFont: true,
  // Air's backgrounds are the six artworks from its Figma frame, over the
  // #EDEBE4 base (src/data/air-design.json); the generative gradient is not
  // part of the design and the selector does not offer it.
  generativeBackground: false,
  // The pixel mosaic overlay is a Releases-channel effect for the IDE
  // artwork; Air's flat illustrations are not designed for it.
  pixelation: false,
  // The Figma file lays every Air template out as a row of three brand
  // treatments, next to the layout axis. The toolbar offers them as the
  // Variant control; AirBanner reads `variantOption` to pick one.
  //
  // The treatments restyle the Air BANNER, so they apply to the sets that
  // banner renders — the ones whose templates carry the `isAirBanner` branch
  // (pages/Releases/WhatsNewPreview, the four Email templates, and the Social
  // templates the Releases channel reuses). The Screenshot set is the shared
  // mockup tool: a screenshot over a background, with no headline or wordmark
  // for a treatment to change, so its layout panel stays the channel's flat
  // row of CDN icons (see `variantsForProduct`).
  variantSets: ["social-media", "whats-new", "emails"],
  // A variant may name the `layouts` its frames exist for; without the field
  // the treatment holds on every layout the policy offers. The logo mark is
  // drawn beside a headline alone and over a subtitle only — the frame pairs
  // no screenshot layout with it — so the grid leaves that one cell out.
  variants: [
    {id: 1, label: "air", hint: "Headline set in JetBrains Modul"},
    {id: 2, label: "air + sans", hint: "The air wordmark over a JetBrains Sans headline"},
    {
      id: 3,
      label: "air logo",
      hint: "Air logo mark in the header, Modul headline",
      layouts: [1, 3],
    },
  ],
};
